// import { postData } from '@/lib/axios';
// import { API_BASE_URL } from '@/constants/api-endpoints.constants';
// import storageService from '@/lib/storage-service';

export const AuditEventAPI = {
  //TODO: Will be removing the pot audit as it will be handled by BE

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
  postAuditEvent: async (payload: any) => {
    try {
      // await postData(`${API_BASE_URL}/emr/fhir/R4/AuditEvent`, payload, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     Accept: 'application/fhir+json',
      //     Authorization: `Bearer ${storageService.getAccessToken()}`,
      //   },
      // });
    } catch (error) {
      console.error({ error });
    }
  },
};